
import { defineComponent } from "vue";

import SideBar from "@/components/SideBar.vue";
import Notifications from "./components/Notifications.vue";

export default defineComponent({
  name: "App",
  data() {
    return {
      isDarkTheme: false,
    };
  },
  methods: {
    toggleTheme(isDarkTheme: boolean) {
      this.isDarkTheme = isDarkTheme;
    },
  },
  components: {
    SideBar,
    Notifications,
  },
});
